// extracted by mini-css-extract-plugin
module.exports = {"ldsDualRing":"style_ldsDualRing__1ol8Y","lds-dual-ring":"style_lds-dual-ring__1mV9t"};